import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "e73c32b8-77d0-4cdc-9ee3-000ea4fa8729", content: "Finite Element Method", options: {} },
  { id: "d479b026-578f-48a9-9fb6-833903cb5448", content: "Boundary Element Method", options: {} },
  { id: "23740494-86b9-489f-80ce-b4f60829a671", content: "Wave based Methods", options: {} },
  { id: "73b382f3-c311-4290-8247-6d5cf484cb90", content: "Polynomial interpolation", options: {} },
  { id: "7d698ee7-1a76-4379-9171-cc89647c6599", content: "Finite-Differences in Time Domain", options: {} },
  { id: "8809021d-ab46-4fb6-9441-fd726e98a8de", content: "Full wave equation resolution", options: {} },
  { id: "088c99b6-6953-4ac8-92bf-2e2a7ad4597d", content: "Radiosity method", options: {} },
  { id: "43da0ea0-d292-4476-8f39-4656560e6f16", content: "Image Source Method", options: {} },
  { id: "f46db009-f00a-4041-99fb-ca5a3739ad2c", content: "Ray tracing ", options: {} },
  { id: "f686a7da-070d-40de-b2f0-800374fab6d2", content: "Energy methods", options: {} },
  { id: "6f0ba34d-6538-4b3a-a7ae-2a21b47b590b", content: "Geometrical acoustics", options: {} },
];

const groups = [
  { id: "967b94f3-17c7-428b-a39f-e5e9894c1f66", content: "Low frequency range", options: {} },
  { id: "af3ebf90-3fd1-451d-9c69-9c299205a730", content: "High frequency range", options: {} },
];

export const task: Task = {
  id: "660a258c-909f-4891-bd4e-03e999c6d23d",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "967b94f3-17c7-428b-a39f-e5e9894c1f66",
      itemsId: [
        "e73c32b8-77d0-4cdc-9ee3-000ea4fa8729",
        "d479b026-578f-48a9-9fb6-833903cb5448",
        "23740494-86b9-489f-80ce-b4f60829a671",
        "73b382f3-c311-4290-8247-6d5cf484cb90",
        "7d698ee7-1a76-4379-9171-cc89647c6599",
        "8809021d-ab46-4fb6-9441-fd726e98a8de",
      ],
    },
    {
      groupId: "af3ebf90-3fd1-451d-9c69-9c299205a730",
      itemsId: [
        "088c99b6-6953-4ac8-92bf-2e2a7ad4597d",
        "43da0ea0-d292-4476-8f39-4656560e6f16",
        "f46db009-f00a-4041-99fb-ca5a3739ad2c",
        "f686a7da-070d-40de-b2f0-800374fab6d2",
        "6f0ba34d-6538-4b3a-a7ae-2a21b47b590b",
      ],
    },
  ],
};
